import { Project } from "../../models/project-field";

export interface ProjectState {
    projectList: Project[];
    loading: boolean;
    error: string | null;
  }
  
  export const initialState: ProjectState = {
    projectList: [],
    loading: false,
    error: null,
  };